import {Action} from 'redux';
import {TOGGLE_LEFT_BAR, TOGGLE_BOTTOM_BAR} from './constants';

export interface ISplitPaneAction extends Action {
  payload?: any;
}

export const toggleLeftBar = (state: boolean): ISplitPaneAction => ({
  type: TOGGLE_LEFT_BAR,
  payload: {leftBarHidden: state},
});

export const toggleBottomBar = (state: boolean): ISplitPaneAction => ({
  type: TOGGLE_BOTTOM_BAR,
  payload: {bottomBarHidden: state},
});
